export default "__VITE_ASSET__DLJeuynA__"